module.exports = __webpack_public_path__ + "img/logout-ar.3e5fdaf1.png";